import * as yup from 'yup';

// Mirrors settings.BLOCKED_SIGNUP_EMAIL_DOMAINS in LIMS, which is the real enforcement point.
export const BLOCKED_SIGNUP_EMAIL_DOMAINS = ['agentmail.to', 'agentmail.io', 'apexblack.org'];

export const BLOCKED_EMAIL_DOMAIN_MESSAGE = 'This email domain is not accepted. Please use a different email.';

// Matches the blocked domain itself and any subdomain of it.
export const isBlockedSignupEmailDomain = (email?: string | null): boolean => {
  if (!email?.includes('@')) return false;

  const domain = `.${email
    .slice(email.lastIndexOf('@') + 1)
    .trim()
    .toLowerCase()
    .replace(/\.+$/, '')}`;

  return BLOCKED_SIGNUP_EMAIL_DOMAINS.some(blockedDomain =>
    domain.endsWith(`.${blockedDomain.trim().toLowerCase().replace(/^@/, '')}`),
  );
};

export const withBlockedEmailDomainTest = (schema: yup.StringSchema): yup.StringSchema =>
  schema.test('blocked-email-domain', BLOCKED_EMAIL_DOMAIN_MESSAGE, value => !isBlockedSignupEmailDomain(value));
